import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_tjgxnz7e4x: FaireCollectionEntity = {
  token: "pbc_tjgxnz7e4x",
  type: "collection",
  name: "Baby Coverall Jumpsuit & Footie (Organic Jersey / Muslin) ",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25be20c1dc96f8d8e25ddf95a3c33b9595aa384144d34c78f5851790729f66da.jpeg",
  itemCount: 48,
  description:
    "Our 'BESTSELLING' baby apparel styles - organic cotton baby coverall jumpsuits in organic jersey & muslin fabrication. \nSoft, natural, breathable, lightweight and durable. Ethically produced in INDIA.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.015Z",
    importedBy: "entity-db-import-collections",
  },
};
